import { useState, useEffect } from "react";
import { API_BASE } from "../../utils/api";
import InfoScreen from "./InfoScreen";
import { useNavigate } from "react-router-dom";

export default function Verify() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [globalError, setGlobalError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [refreshToken, setRefreshToken] = useState<string | null>(null);
  const navigate = useNavigate();

  // Parse the access_token from the URL hash
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const error = params.get("error");
      const message = params.get("message");
      const errorDescription = params.get("error_description");
      if (error) {
        setGlobalError(errorDescription || "Something went wrong.");
        return;
      }
      const accessToken = params.get("access_token");
      const refreshToken = params.get("refresh_token");

      if (message) { 
        setSuccess(message);
        return;
      }

      if (accessToken) {
        setToken(accessToken);
      } else {
        setGlobalError("Missing token. Cannot verify email.");
        return;
      }

      if (refreshToken) {
        setRefreshToken(refreshToken);
      } else {
        setGlobalError("Missing refresh token. Cannot verify email.");
        return;
      }
    } else {
      navigate("/")
    }
  }, [navigate]);

  // If there's a global error, show info screen instead of the form
  if (globalError) {
    return (
      <InfoScreen
        title="Well... this sucks"
        description={globalError}
        buttonText="Home"
        buttonLink="/"
      />
    );
  }

  return (
      <InfoScreen
        title="You're all set!"
        description={success || "Your email is verified. Let's start playing!"}
        buttonText="Home"
        buttonLink="/"
      />
  );
}
